// src/pages/tenant/ReviewPayment.jsx
import React from 'react';
import { Box, Typography, Paper, Divider, Button, Grid } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';

export default function ReviewPayment() {
  const { state } = useLocation();
  const navigate = useNavigate();

  if (!state) {
    return <Typography>Missing payment info</Typography>;
  }

  const {
    paymentAmount,
    fee,
    total,
    formattedDate,
    paymentMethod,
  } = state;

  const paymentLabel =
    paymentMethod === 'card' ? 'Credit card ending in 7425' : 'Bank account';
  const feeLabel =
    paymentMethod === 'card' ? 'Credit card service fee' : 'Bank service fee';

  return (
    <Box maxWidth="700px" mx="auto" my={5}>
      <Typography variant="h6" mb={2}>Review payment</Typography>

      <Paper elevation={3} sx={{ p: 4, borderRadius: 3 }}>
        <Typography fontSize={28} fontWeight={700} mb={2}>
          Amount to be paid
        </Typography>
        <Typography fontSize={28} fontWeight={700} mb={2}>
          ${total.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
        </Typography>

        <Divider sx={{ my: 2 }} />

        

        <Box mt={2}>
          <Grid container>
            <Grid item xs={6}>
              <Typography>Memphis Passive LLC</Typography>
            </Grid>
            <Grid item xs={6} textAlign="right">
              <Typography>
                ${paymentAmount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography>{feeLabel}</Typography>
            </Grid>
            <Grid item xs={6} textAlign="right">
              <Typography>
                ${fee.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
              </Typography>
            </Grid>
          </Grid>
        </Box>

        <Divider sx={{ my: 2 }} />

        <Box display="flex" justifyContent="space-between" mb={1}>
          <Typography fontWeight={600}>Total</Typography>
          <Typography fontWeight={600}>
            ${total.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          </Typography>
        </Box>

        <Grid container spacing={2} mt={2}>
          <Grid item xs={4}>
            <Typography fontSize={13} color="text.secondary">
              Payment date
            </Typography>
            <Typography fontWeight={600}>{formattedDate}</Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography fontSize={13} color="text.secondary">
              Paid by
            </Typography>
            <Typography fontWeight={600}>Tenant</Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography fontSize={13} color="text.secondary">
              Payment method
            </Typography>
            <Typography fontWeight={600}>{paymentLabel}</Typography>
          </Grid>
        </Grid>

        <Typography fontSize={12} color="text.secondary" mt={3}>
          By clicking <strong>Submit payment</strong>, I authorize the above amount to
          be withdrawn from my account. If any payment is returned or rejected, I
          may be charged additional fees. I am aware that all signatories are
          responsible for paying the account balance. Payments are nonrefundable.
        </Typography>

        <Box display="flex" gap={2} mt={4}>
          <Button
            fullWidth
            variant="outlined"
            onClick={() => navigate('/tenant/makePayment')}
          >
            Cancel
          </Button>
          <Button
            fullWidth
            variant="contained"
            color="success"
            onClick={() =>
            navigate('/tenant/paymentProcessing', {
                state: {
                paymentAmount,
                paymentMethod,
                formattedDate,
                fee,
                total,
                },
            })
}
          >
            Submit payment
          </Button>
        </Box>
      </Paper>
    </Box>
  );
}